import React from 'react';
import loadable from '@loadable/component';
import Loading from '@components/Loading';

const Dashboard = loadable(() => import(/* webpackChunkName: "dashboard" */ './Container'), {
  fallback: <Loading />,
});

export default Dashboard;
